module.exports = __webpack_public_path__ + "static/media/hangmanPreview.a033a608.png";